<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleDetail(scope.row,scope.index)"
          >详情</el-button>
          <!-- <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >删除</el-button> -->
        </template>
        <template
          slot-scope="scope"
          slot="labelName"
        >
          <span>{{scope.row.labelName?(scope.row.labelName.length>13)?scope.row.labelName.slice(0,13)+'..':scope.row.labelName:''}}</span>
          <a
            href="#"
            @click="openMore(scope.row)"
            v-if="scope.row.labelName?(scope.row.labelName.length>13):false"
            style="text-decoration: underline;color:rgb(48, 133, 230)"
          >{{moreTemplate}}</a>
        </template>
      </avue-crud>
      <el-dialog
        title="标签"
        :visible.sync="moreDialog"
        width="40%"
      >
        <el-form :model="redpacketform">
          <el-form-item
            :label="tagsClientType"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              v-model="redpacketform.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分组标签"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="redpacketform.labelIds"
              clearable
              disabled
              multiple
              placeholder="请选择标签"
            >
              <el-option
                v-for="item in classifySelects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <span>分组标签:</span> -->
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="moreDialog = false">取 消</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { promotersStatisticsOption } from "@/const/salesCloud/promotersStatisticsOption";
import {
  findPromotionList,
  addSystemClassify,
  editSystemClassify,
  delSystemClassify
} from "@/api/salesCloud/promotersStatistics";
import { findLabelList } from "@/api/salesCloud/setTags";
export default {
  name: "promotersStatistics",
  data() {
    return {
      tableOption: promotersStatisticsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      classifySelects: [],
      currClassify: "",
      redpacketform: {},
      moreDialog: false,
      moreTemplate: "更多",
      tabelObj: {},
      tagsClientType: "",
      formLabelWidth: "120px",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    openMore(row) {
      this.clean();
      console.log(row);
      this.tagsClientType =
        row.clientType == "JOINS_PROMOTION_SPECIALIST"
          ? "推广员端"
          : row.clientType == "JOINS_MERCHANT"
          ? "商户端"
          : row.clientType == "JOINS_ENGINEER"
          ? "工程师端"
          : "error";
      this.redpacketform = {};
      let params = {
        clientType: row.clientType
      };
      findLabelList(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        console.log(data);
        this.totalPeople = data.all;
        data = data.list.map(item => {
          item.name = item.name + "(" + item.count + ")";
          return item;
        });
        this.classifySelects = data;
      });
      this.redpacketform.name = row.name;
      this.redpacketform.labelIds = row.labelId.split(",");
      console.log(this.redpacketform);
      this.moreDialog = true;
    },
    handleDetail(row, index) {
      console.log(row);
      let params = { id: row.id };
      this.$router.push({ name: "推广员分销统计详情", params });
    },
    clean() {
      this.currClassify = "";
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findPromotionList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findPromotionList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        delete params.startTime;
        delete params.endTime;
      }
      findPromotionList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      findPromotionList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findPromotionList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.rootId = this.currClassify;
      console.log(row);
      addSystemClassify(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delSystemClassify(row.id).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      let params = {};
      params.id = row.id;
      if (row.name) {
        params.name = row.name.replace(/(^\s*)|(\s*$)/g, "");
        params.rootId = row.rootId;
      }
      if (!row.name.replace(/(^\s*)|(\s*$)/g, "")) {
        this.$message({
          showClose: true,
          message: "工程进度名称不能为空",
          type: "error"
        });
        done();
        return;
      }
      editSystemClassify(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
